import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { sdk } from "@/api/sdk";
import { InviteJoin } from "@/features/booking/modules/invite-join/invite-join";
import { m } from "@/paraglide/messages.js";

/**
 * Where the button in a trainer's invite email lands. Someone without a session goes to sign-up
 * with the code filled in (and from there to sign-in if they turn out to have an account, which
 * brings them back here). Someone signed in joins the trainer right away.
 */
export const Route = createFileRoute("/(public)/join/")({
  staticData: { sitemap: false },
  component: RouteComponent,
  // The session cookie is not on the server's request; see the (private) route.
  ssr: false,
  validateSearch: z.object({ code: z.string().max(32).catch("") }),
  beforeLoad: async ({ search }) => {
    if (!search.code) throw redirect({ to: "/dashboard" });
    const { data } = await sdk.users.me.$get.send();
    if (!data) throw redirect({ to: "/signup", search: { code: search.code } });
  },
  loader: () => ({ crumb: m.booking_invite_crumb() }),
});

function RouteComponent() {
  const { code } = Route.useSearch();
  return (
    <main className="flex min-h-svh items-center justify-center bg-background px-4 py-10">
      <InviteJoin code={code} />
    </main>
  );
}
